var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _MessagesState_instances, _MessagesState_maxChatMessages, _MessagesState_onDuplicateMessage, _MessagesState_sessionId, _MessagesState_optimisticMessageCount, _MessagesState_deletedOptimisticMessageKeys, _MessagesState_messages, _MessagesState_loadedRanges, _MessagesState_prependBatch, _MessagesState_appendBatch, _MessagesState_getOptimisticId, _MessagesState_updateLoadedRanges, _MessagesState_truncateLoadedRangesEnd, _MessagesState_truncateLoadedRangesStart;
import { pubnubRange, } from "./range";
import { STAGE_TEN_SOURCE_NAME } from "./types";
import { randomString } from "./util/randomString";
export class MessagesState {
    constructor({ maxChatMessages, onDuplicateMessage }) {
        _MessagesState_instances.add(this);
        _MessagesState_maxChatMessages.set(this, void 0);
        _MessagesState_onDuplicateMessage.set(this, void 0);
        _MessagesState_sessionId.set(this, randomString());
        _MessagesState_optimisticMessageCount.set(this, 0
        // Tracks message keys for optimistic messages which were deleted, before
        // we got the real message with timetoken back from PubNub. These messages
        // will be removed from state, so we need to track their keys, to ensure we
        // don't re-add the messages back into state when we get them from PubNub.
        // Note that we don't ever remove values from this list, because the chat client
        // may have behaviour which adds the same message more than once. So in theory
        // this could grow infinitely, but in practice it handles an edge case that
        // I'm sure occurs approximately 0% of the time.
        );
        // Tracks message keys for optimistic messages which were deleted, before
        // we got the real message with timetoken back from PubNub. These messages
        // will be removed from state, so we need to track their keys, to ensure we
        // don't re-add the messages back into state when we get them from PubNub.
        // Note that we don't ever remove values from this list, because the chat client
        // may have behaviour which adds the same message more than once. So in theory
        // this could grow infinitely, but in practice it handles an edge case that
        // I'm sure occurs approximately 0% of the time.
        _MessagesState_deletedOptimisticMessageKeys.set(this, []);
        _MessagesState_messages.set(this, new Map());
        _MessagesState_loadedRanges.set(this, []);
        this.add = (message) => {
            if (isNotOptimisticMessage(message)) {
                __classPrivateFieldGet(this, _MessagesState_appendBatch, "f").call(this, [message], [...__classPrivateFieldGet(this, _MessagesState_messages, "f").values()]);
                return message;
            }
            const messages = new Map(__classPrivateFieldGet(this, _MessagesState_messages, "f"));
            if (__classPrivateFieldGet(this, _MessagesState_messages, "f").size === __classPrivateFieldGet(this, _MessagesState_maxChatMessages, "f")) {
                const oldestMessageKey = messages.keys().next().value;
                messages.delete(oldestMessageKey);
            }
            const messageKey = __classPrivateFieldGet(this, _MessagesState_instances, "m", _MessagesState_getOptimisticId).call(this);
            const optimisticMessage = Object.assign(Object.assign({}, message), { messageKey, isMe: true, timestampMs: Date.now(), sourceName: STAGE_TEN_SOURCE_NAME });
            messages.set(messageKey, optimisticMessage);
            __classPrivateFieldSet(this, _MessagesState_messages, messages, "f");
            return optimisticMessage;
        };
        /**
         * Add a batch of messages. Please note the following behaviours:
         *
         *  - If all messages in the batch are older than messages currently in state,
         *    and the total count of messages of the batch merged with messages in state
         *    exceeds maxChatMessages, then the newest messages in state, after the batch
         *    is merged, will be discarded.
         *
         *  - If some messages in the batch are newer than the oldest message in state,
         *    and the total count of messages of the batch merged with messages in state
         *    exceeds maxChatMessages, then the oldest messages in state, after the batch
         *    is merged, will be discarded.
         *
         *  - If `range` is provided, this class will treat `batch` as a continuous range
         *    of messages from the user's channel. That is, if the caller subsequently calls
         *    `truncateFetchRange`, with a range that overlaps with this `range`, it may
         *    be truncated (according to range merge / truncation logic), because it is
         *    assumed that no other messages can possibly exist in that range, and since the
         *    range is already loaded in state, there is no point in re-fetching messages
         *    in that range.
         *
         * Some more details about `range`:
         *
         * If the caller knows this information, passing `start` and `end` here can help
         * this class find contiguous ranges of loaded state and merge them, making it
         * simpler to truncate future fetches, or remove the need to fetch altogether.
         * Looking only at the timestamps of messages in a batch would lead to small gaps
         * between loaded ranges.
         *
         * Callers should be aware that, for a few reasons, you might not know
         * the start or end times, so please exercise care. For example:
         *   - No `start` value was passed to PubNub (i.e. we are fetching from current
         *     time, whatever that is, and moving backward).
         *   - The number of messages in a given range may have exceeded the fetch `limit`,
         *     so the contents of `batch` here does not represent all the messages
         *     in the requested range.
         */
        this.addBatch = (batch, range) => {
            if (range) {
                // This updates the loaded ranges for this batch. Two notes:
                //  - It's important that we do this regardless of whether the batch has messages.
                //    If the given range has no messages, that's useful to know.
                //  - After the batch is merged, the loaded ranges may be updated again, in the
                //    event that some messages in state (or the batch) were discarded because we hit
                //    maxChatMessages.
                __classPrivateFieldGet(this, _MessagesState_instances, "m", _MessagesState_updateLoadedRanges).call(this, batch, range);
            }
            if (!batch.length) {
                return;
            }
            // Discard reactions, since that state is stored separately
            const batchWithoutReactions = batch.map((_a) => {
                var { reactions } = _a, messageWithoutReactions = __rest(_a, ["reactions"]);
                return messageWithoutReactions;
            });
            // Note: If maxChatMessages was an unusually low value (think: single digit),
            // I think this could introduce some edge cases where the below logic
            // would lead to undesirable behaviour.
            const existingMessages = [...__classPrivateFieldGet(this, _MessagesState_messages, "f").values()];
            const newestMessageInBatch = batchWithoutReactions[batchWithoutReactions.length - 1];
            const oldestMessageInState = existingMessages.find(isNotOptimisticMessage);
            if (oldestMessageInState &&
                newestMessageInBatch.timetoken < oldestMessageInState.timetoken) {
                __classPrivateFieldGet(this, _MessagesState_prependBatch, "f").call(this, batchWithoutReactions, existingMessages);
            }
            else {
                __classPrivateFieldGet(this, _MessagesState_appendBatch, "f").call(this, batchWithoutReactions, existingMessages);
            }
        };
        _MessagesState_prependBatch.set(this, (batch, existingMessages) => {
            /**
             * The logic below is nearly identical to that in `appendBatch`, except that we start
             * from the oldest messages and discard newer ones if we exceed maxChatMessages.
             */
            var _a, _b, _c;
            let messagesIndex = 0;
            let batchIndex = 0;
            const newEntries = [];
            const seenMessagesKeys = {};
            do {
                const existingMessage = existingMessages[messagesIndex];
                const batchMessage = batch[batchIndex];
                let nextMessageToAdd;
                if (batchMessage && seenMessagesKeys[batchMessage.messageKey]) {
                    // This message is a duplicate. Don't add to state.
                    batchIndex++;
                    __classPrivateFieldGet(this, _MessagesState_onDuplicateMessage, "f").call(this, batchMessage.timetoken);
                }
                else if (existingMessage &&
                    seenMessagesKeys[existingMessage.messageKey]) {
                    // This message is a duplicate. Don't add to state.
                    messagesIndex++;
                    if (existingMessage.timetoken !== undefined) {
                        __classPrivateFieldGet(this, _MessagesState_onDuplicateMessage, "f").call(this, existingMessage.timetoken);
                    }
                }
                else if (existingMessage &&
                    batchMessage &&
                    (existingMessage.timetoken === batchMessage.timetoken ||
                        existingMessage.messageKey === batchMessage.messageKey)) {
                    // These are the same message, so we replace the existing message with the
                    // one from the batch.
                    nextMessageToAdd = batchMessage;
                    batchIndex++;
                    messagesIndex++;
                }
                else if (!batchMessage ||
                    (existingMessage &&
                        existingMessage.timestampMs < batchMessage.timestampMs)) {
                    // Either the batch has been emptied or the message in the batch is newer
                    // than the existing message in state.
                    nextMessageToAdd = existingMessage;
                    messagesIndex++;
                }
                else {
                    // All existing messages in state have been added, OR the batch message is
                    // older than the existing state message.
                    const wasDeletedOptimistically = __classPrivateFieldGet(this, _MessagesState_deletedOptimisticMessageKeys, "f").lastIndexOf(batchMessage.messageKey) > -1;
                    if (!wasDeletedOptimistically) {
                        nextMessageToAdd = batchMessage;
                    }
                    batchIndex++;
                }
                if (nextMessageToAdd) {
                    const { timetoken, messageKey } = nextMessageToAdd;
                    newEntries.push([
                        (timetoken !== null && timetoken !== void 0 ? timetoken : messageKey).toString(),
                        nextMessageToAdd,
                    ]);
                    seenMessagesKeys[messageKey] = true;
                }
            } while ((messagesIndex < existingMessages.length || batchIndex < batch.length) &&
                newEntries.length < __classPrivateFieldGet(this, _MessagesState_maxChatMessages, "f"));
            __classPrivateFieldSet(this, _MessagesState_messages, new Map(newEntries), "f");
            const previouslyNewestTimetokenInState = (_a = existingMessages.findLast(isNotOptimisticMessage)) === null || _a === void 0 ? void 0 : _a.timetoken;
            const currentNewestTimetokenInState = (_c = (_b = newEntries.findLast(isEntryNotOptimistic)) === null || _b === void 0 ? void 0 : _b[1]) === null || _c === void 0 ? void 0 : _c.timetoken;
            if (currentNewestTimetokenInState !== undefined &&
                ((previouslyNewestTimetokenInState !== undefined &&
                    previouslyNewestTimetokenInState !== currentNewestTimetokenInState) ||
                    newEntries.length < batch.length)) {
                // One or more messages were discarded because we hit maxChatMessages.
                // We need to update the loaded ranges.
                __classPrivateFieldGet(this, _MessagesState_instances, "m", _MessagesState_truncateLoadedRangesStart).call(this, currentNewestTimetokenInState);
            }
        });
        _MessagesState_appendBatch.set(this, (batch, existingMessages) => {
            /**
             * We make the following assumptions:
             *    - The current messages in state are sorted by timetoken
             *    - Messages in `batch` are also sorted by timetoken
             *    - Where a message in `batch` matches, by timetoken, an
             *      existing message in state, the message in the batch
             *      is more up to date.
             *
             * We do not assume:
             *    - Messages in the batch are newer than messages in state
             *    - Messages in the batch correspond to any optimistic messages
             *      in state.
             *
             * This means we don't know how much of the existing state and how
             * much of the batch we need to include in the final, merged state.
             * So our approach is to work backwards from the newest messages
             * from each, and check for updates to optimistic messages.
             */
            var _a, _b;
            let messagesIndex = existingMessages.length - 1;
            let batchIndex = batch.length - 1;
            const newEntries = [];
            // Track which messages we've seen, by their messageKey. Because messageKey is meant
            // to uniquely identify the message for the local user, we can't allow duplicates.
            const seenMessagesKeys = {};
            do {
                const existingMessage = existingMessages[messagesIndex];
                const batchMessage = batch[batchIndex];
                let nextMessageToAdd;
                if (batchMessage && seenMessagesKeys[batchMessage.messageKey]) {
                    // This message is a duplicate. Don't add to state.
                    batchIndex--;
                    __classPrivateFieldGet(this, _MessagesState_onDuplicateMessage, "f").call(this, batchMessage.timetoken);
                }
                else if (existingMessage &&
                    seenMessagesKeys[existingMessage.messageKey]) {
                    // This message is a duplicate. Don't add to state.
                    messagesIndex--;
                    if (existingMessage.timetoken !== undefined) {
                        __classPrivateFieldGet(this, _MessagesState_onDuplicateMessage, "f").call(this, existingMessage.timetoken);
                    }
                }
                else if (existingMessage &&
                    batchMessage &&
                    (existingMessage.timetoken === batchMessage.timetoken ||
                        existingMessage.messageKey === batchMessage.messageKey)) {
                    // These are the same message, so we replace the existing message with the
                    // one from the batch.
                    nextMessageToAdd = batchMessage;
                    batchIndex--;
                    messagesIndex--;
                }
                else if (!batchMessage ||
                    (existingMessage &&
                        existingMessage.timestampMs > batchMessage.timestampMs)) {
                    // Either the batch has been emptied or the message in the batch is older
                    // than the existing message in state.
                    nextMessageToAdd = existingMessage;
                    messagesIndex--;
                }
                else {
                    // All existing messages in state have been added, OR the batch message is
                    // newer than the existing state message.
                    // Note that we do not check if `batchMessage` is defined, because our loop
                    // condition (messagesIndex >= 0 || batchIndex >= 0) enforces that
                    // at least one of `existingMessage` or `batchMessage` will always be defined.
                    const wasDeletedOptimistically = __classPrivateFieldGet(this, _MessagesState_deletedOptimisticMessageKeys, "f").lastIndexOf(batchMessage.messageKey) > -1;
                    if (!wasDeletedOptimistically) {
                        nextMessageToAdd = batchMessage;
                    }
                    batchIndex--;
                }
                if (nextMessageToAdd) {
                    const { timetoken, messageKey } = nextMessageToAdd;
                    newEntries.unshift([
                        (timetoken !== null && timetoken !== void 0 ? timetoken : messageKey).toString(),
                        nextMessageToAdd,
                    ]);
                    seenMessagesKeys[messageKey] = true;
                }
            } while ((messagesIndex >= 0 || batchIndex >= 0) &&
                newEntries.length < __classPrivateFieldGet(this, _MessagesState_maxChatMessages, "f"));
            __classPrivateFieldSet(this, _MessagesState_messages, new Map(newEntries), "f");
            const previouslyOldestTimetokenInState = (_a = existingMessages.find(isNotOptimisticMessage)) === null || _a === void 0 ? void 0 : _a.timetoken;
            const currentOldestTimetokenInState = (_b = newEntries.find(isEntryNotOptimistic)) === null || _b === void 0 ? void 0 : _b[1].timetoken;
            if (currentOldestTimetokenInState !== undefined &&
                ((previouslyOldestTimetokenInState !== undefined &&
                    previouslyOldestTimetokenInState !== currentOldestTimetokenInState) ||
                    newEntries.length < batch.length)) {
                // One or more messages were discarded because we hit maxChatMessages.
                // We need to update the loaded ranges.
                __classPrivateFieldGet(this, _MessagesState_instances, "m", _MessagesState_truncateLoadedRangesEnd).call(this, currentOldestTimetokenInState);
            }
        });
        this.remove = (messageKeyOrTimetoken) => {
            var _a;
            const messageToRemove = [...__classPrivateFieldGet(this, _MessagesState_messages, "f").values()].findLast(({ messageKey, timetoken }) => messageKey === messageKeyOrTimetoken ||
                timetoken === messageKeyOrTimetoken);
            if (messageToRemove) {
                const messages = new Map(__classPrivateFieldGet(this, _MessagesState_messages, "f"));
                const mapKey = ((_a = messageToRemove.timetoken) !== null && _a !== void 0 ? _a : messageToRemove.messageKey).toString();
                messages.delete(mapKey);
                if (messageToRemove.timetoken === undefined) {
                    __classPrivateFieldGet(this, _MessagesState_deletedOptimisticMessageKeys, "f").push(messageToRemove.messageKey);
                }
                __classPrivateFieldSet(this, _MessagesState_messages, messages, "f");
            }
            return messageToRemove;
        };
        this.clear = () => {
            const optimisticMessageKeys = [...__classPrivateFieldGet(this, _MessagesState_messages, "f").values()]
                .filter(({ timetoken }) => timetoken === undefined)
                .map(({ messageKey }) => messageKey);
            __classPrivateFieldGet(this, _MessagesState_deletedOptimisticMessageKeys, "f").push(...optimisticMessageKeys);
            __classPrivateFieldSet(this, _MessagesState_messages, new Map(), "f");
            __classPrivateFieldSet(this, _MessagesState_loadedRanges, [], "f");
        };
        this.getLoadedRangeIntersecting = (timetoken) => {
            return __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").findLast(({ end, start }) => end <= timetoken && start > timetoken);
        };
        __classPrivateFieldSet(this, _MessagesState_maxChatMessages, maxChatMessages, "f");
        __classPrivateFieldSet(this, _MessagesState_onDuplicateMessage, onDuplicateMessage, "f");
    }
    get state() {
        return __classPrivateFieldGet(this, _MessagesState_messages, "f");
    }
    truncateFetchRange({ start: startTime, end: endTime, }) {
        const rangeIntersectingStart = typeof startTime === "bigint" &&
            __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").findLast(({ end, start }) => end <= startTime && start >= startTime);
        const rangeIntersectingEnd = typeof endTime === "bigint" &&
            __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").find(({ end, start }) => start >= endTime && end <= endTime);
        if (rangeIntersectingStart &&
            rangeIntersectingEnd &&
            rangeIntersectingStart === rangeIntersectingEnd) {
            // This range is already loaded. The caller should check that
            // endTime < startTime before fetching
            return {
                end: startTime,
                start: startTime,
            };
        }
        return {
            end: rangeIntersectingEnd ? rangeIntersectingEnd.start : endTime,
            start: rangeIntersectingStart ? rangeIntersectingStart.end : startTime,
        };
    }
}
_MessagesState_maxChatMessages = new WeakMap(), _MessagesState_onDuplicateMessage = new WeakMap(), _MessagesState_sessionId = new WeakMap(), _MessagesState_optimisticMessageCount = new WeakMap(), _MessagesState_deletedOptimisticMessageKeys = new WeakMap(), _MessagesState_messages = new WeakMap(), _MessagesState_loadedRanges = new WeakMap(), _MessagesState_prependBatch = new WeakMap(), _MessagesState_appendBatch = new WeakMap(), _MessagesState_instances = new WeakSet(), _MessagesState_getOptimisticId = function _MessagesState_getOptimisticId() {
    var _a, _b;
    return `${__classPrivateFieldGet(this, _MessagesState_sessionId, "f")}-${__classPrivateFieldSet(this, _MessagesState_optimisticMessageCount, (_b = __classPrivateFieldGet(this, _MessagesState_optimisticMessageCount, "f"), _a = _b++, _b), "f"), _a}`;
}, _MessagesState_updateLoadedRanges = function _MessagesState_updateLoadedRanges(messages, { start: newRangeStart, end: newRangeEnd }) {
    if (!messages.length) {
        console.assert(typeof newRangeStart === "bigint" && typeof newRangeEnd === "bigint", "When a message batch is empty, newRangeStart and newRangeEnd must be defined");
    }
    console.assert(!newRangeStart || !newRangeEnd || newRangeStart > newRangeEnd, "Supplied range is out of order");
    const newRange = pubnubRange({
        end: typeof newRangeEnd === "bigint" ? newRangeEnd : messages[0].timetoken,
        start: typeof newRangeStart === "bigint"
            ? newRangeStart
            : // Add +1 so that the start of the range is exclusive of this message
                messages[messages.length - 1].timetoken + BigInt(1),
    });
    if (!__classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").length) {
        __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").push(newRange);
        return;
    }
    // The index for an existing range, the `start` value of which
    // follows (or is equal to) `newRange.start`
    const startIndex = __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").findIndex(({ start }) => start >= newRange.start);
    // The index for an existing range, the `end` value of which
    // precedes (or is equal to) `newRange.end`
    const endIndex = __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").findLastIndex(({ end }) => end <= newRange.end);
    if (startIndex > -1 && endIndex > -1 && startIndex === endIndex) {
        // This range is already loaded
        return;
    }
    const rangeAtStartIndex = __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f")[startIndex];
    const isContinuousWithStartRange = rangeAtStartIndex && rangeAtStartIndex.end <= newRange.start;
    const rangeAtEndIndex = __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f")[endIndex];
    const isContinuousWithEndRange = rangeAtEndIndex && rangeAtEndIndex.start >= newRange.end;
    const startIndexOrLength = startIndex > -1 ? startIndex : __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").length;
    const numberOfFullyOverlappingRanges = startIndexOrLength - endIndex - 1;
    if (isContinuousWithStartRange && isContinuousWithEndRange) {
        // Merge with the fully overlapped ranges, plus the two that partially overlap,
        // or are contiguous.
        __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").splice(endIndex, numberOfFullyOverlappingRanges + 2, {
            start: rangeAtStartIndex.start,
            end: rangeAtEndIndex.end,
        });
    }
    else if (isContinuousWithStartRange) {
        // Delete the fully overlapped ranges, and merge with the preceding range.
        __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").splice(endIndex + 1, numberOfFullyOverlappingRanges + 1, {
            start: rangeAtStartIndex.start,
            end: newRange.end,
        });
    }
    else if (isContinuousWithEndRange) {
        // Delete the fully overlapped ranges, and merge with the following range.
        __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").splice(endIndex, numberOfFullyOverlappingRanges + 1, {
            start: newRange.start,
            end: rangeAtEndIndex.end,
        });
    }
    else {
        // Don't merge, just insert. Note that we still may need to delete ranges.
        __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").splice(endIndex + 1, numberOfFullyOverlappingRanges, {
            start: newRange.start,
            end: newRange.end,
        });
    }
}, _MessagesState_truncateLoadedRangesEnd = function _MessagesState_truncateLoadedRangesEnd(timetoken) {
    const intersectingRangeIndex = __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").findIndex(({ start }) => start > timetoken);
    if (intersectingRangeIndex > -1) {
        __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").splice(0, intersectingRangeIndex + 1, {
            start: __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f")[intersectingRangeIndex].start,
            end: timetoken,
        });
    }
}, _MessagesState_truncateLoadedRangesStart = function _MessagesState_truncateLoadedRangesStart(timetoken) {
    const intersectingRangeIndex = __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").findLastIndex(({ end }) => end <= timetoken);
    if (intersectingRangeIndex > -1) {
        __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").splice(intersectingRangeIndex, __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f").length - intersectingRangeIndex, {
            // Add +1 so that the range is exclusive of the message at `timetoken`
            start: timetoken + BigInt(1),
            end: __classPrivateFieldGet(this, _MessagesState_loadedRanges, "f")[intersectingRangeIndex].end,
        });
    }
};
function isEntryNotOptimistic(entry) {
    return entry[1].timetoken !== undefined;
}
export function isNotOptimisticMessage(message) {
    return "timetoken" in message && typeof message.timetoken === "bigint";
}
